export function LeadOfficeTeamService($http, $q, apexApiUrl) {
    'ngInject';
    return {
        createLeadOfficeTeam: createLeadOfficeTeam,
        retrieveLeadOfficeTeams: retrieveLeadOfficeTeams,
        updateLeadOfficeTeam: updateLeadOfficeTeam,
        deleteLeadOfficeTeam: deleteLeadOfficeTeam
    };

    function retrieveLeadOfficeTeams() {
        return $http({
            method: "GET",
            url: apexApiUrl + "lead-office-teams",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function createLeadOfficeTeam(data) {

        return $http({
            method: "POST",
            data: data,
            url: apexApiUrl + "lead-office-teams",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateLeadOfficeTeam(id, leadOfficeTeam) {

        return $http({
            method: "PUT",
            url: apexApiUrl + "lead-office-teams/" + id,
            data: leadOfficeTeam

        });
    }

    function deleteLeadOfficeTeam(id) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "lead-office-teams/" + id
        });
    }
}
